import React from 'react';
import { Modal as ReactModal } from 'react-bootstrap';

export default function UnsavedObjectModal(props, context) {
  const i18n = context.i18n || { t: (str) => str };
  return (
    <ReactModal show={ true } onHide={ props.onClose } backdrop="static" keyboard={ false }>
      <ReactModal.Header closeButton>
        <ReactModal.Title>{ props.title || i18n.t('Warning') }</ReactModal.Title>
      </ReactModal.Header>
      <ReactModal.Body className="box">
        { props.children }
      </ReactModal.Body>
      <ReactModal.Footer>
        <button onClick={ props.onClickCancel } disabled={ props.loading } type="button" className="btn btn-info">
          { i18n.t('Cancel') }
        </button>
        <button onClick={ props.onClickDiscard } disabled={ props.loading } type="button" className="btn btn-danger">
          { i18n.t('Discard') }
        </button>
        <button onClick={ props.onClickSave } disabled={ props.loading } type="button" className="btn btn-success">
          { i18n.t('Save') }
        </button>
      </ReactModal.Footer>
    </ReactModal>
  );
}

UnsavedObjectModal.contextTypes = {
  i18n: React.PropTypes.object
};



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/UnsavedObjectModal.jsx